import type { TFrame } from '@lucimark/shared/models/playlist'
import { AssetType } from '@lucimark/shared/models/asset-type'
import { isVideoPlaybackMediaKind } from '@/helpers/playbackAssetHelpers'

/**
 * True when the on-air frame should paint via a `<video>` element.
 * Prefers facet `type` (playlist intent). When type is missing, falls back to the
 * asset-index media kind (mounted video/HLS) so diagnostics do not report false negatives.
 */
export function frameMainExpectsVideo(
  frame: Pick<TFrame, 'facets'> | null | undefined,
  mainMediaKind: string
): boolean {
  const mainType = frame?.facets?.main?.type
  if (mainType === AssetType.Video) {
    return true
  }
  if (mainType != null) {
    return false
  }
  return isVideoPlaybackMediaKind(mainMediaKind)
}
